import { render } from "./CompanyCreditAndAccountingPeriodForm.vue?vue&type=template&id=0f0a5f6f&scoped=true&ts=true"
import script from "./CompanyCreditAndAccountingPeriodForm.vue?vue&type=script&lang=ts"
export * from "./CompanyCreditAndAccountingPeriodForm.vue?vue&type=script&lang=ts"

import "./CompanyCreditAndAccountingPeriodForm.vue?vue&type=style&index=0&id=0f0a5f6f&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0a5f6f"]])

export default __exports__